import React from 'react';
import { IComponentContact } from '../../component';
import { inject, observer } from 'mobx-react';
import Contact from './Contact';

const AllForContact = function(props: IComponentContact) {
  return (
    <div className="all-for-contact">
      <Contact {...props} />
    </div>
  );
};

// export default inject('rootStore')(observer(AllForActInfo));
export default AllForContact;
